import { MarvinConfig } from '@Constants/MarvinConstants';
import forEach from 'lodash/forEach';

export const isReaction = (molData) => molData && molData.indexOf('$RXN') === 0;

export const getBoundCount = (molfile, boundPosition = MarvinConfig.defaultBoundPosition) => {
  let bounds = 0;

  forEach(molfile.split('\n'), (line) => {
    if (line.indexOf('COUNTS') !== -1) {
      bounds += Number(line.trim().replace(/ +/g, ',').split(',')[boundPosition]);
    }
  });

  // increasing number of bonds to enlarge the preview for small reactions
  bounds += isReaction(molfile) && bounds < 5 ? 5 : 0;

  return bounds;
};

export const getParams = (bondCount = 0) => {
  const config = MarvinConfig.imageSizeByCountOfBounds;
  switch (true) {
    case bondCount >= 1 && bondCount <= 10:
      return config['1-10'];
    case bondCount >= 11 && bondCount <= 20:
      return config['11-20'];
    case bondCount >= 21 && bondCount <= 50:
      return config['21-50'];
    case bondCount >= 51:
      return config['51-...'];
    default:
      return config.defaults;
  }
};

const MarvinHelpers = { isReaction, getBoundCount, getParams };

export default MarvinHelpers;
